import axios from "axios";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import { useDispatch } from "react-redux";
import adminActions from "../../Redux/actions";
import "./Login.css";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const history = useHistory();

  async function handleSubmit(ev) {
    ev.preventDefault();
    try {
      const { data: adminData } = await axios.post(
        process.env.REACT_APP_API_URL + "/admin/token",
        {
          email,
          password,
        }
      );
      dispatch(adminActions.login({ ...adminData, messageLogged: true }));
      history.push("/admin/dashboard");
    } catch (error) {
      console.error(error.message);
    }
  }
  return (
    <div className="p-2 Login mb-5">
      <h1 className="text-center mb-4">SIGN IN</h1>

      <div className="row form-container">
        <form className="col-xs-12 mb-5" onSubmit={handleSubmit}>
          <div className="input-container mb-3">
            <label htmlFor="Email">Email Address:</label>
            <input
              type="email"
              id="Email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="input-container mb-5">
            <label htmlFor="Password">Password:</label>
            <input
              type="password"
              id="Password"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <div className="d-flex align-items-center justify-content-center box-3  btn-login ">
            <button
              className="btn btn-three d-flex align-items-center justify-content-center text-white btn-login"
              type="submit"
            >
              LOGIN
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
